import React from 'react';
import { TextCursorInput, Image as ImageIcon, Table as TableIcon, Sigma } from 'lucide-react';
import styles from '../../../styles/index.module.scss';

const HINTS = [
    { icon: <TextCursorInput size={16} />, title: '选中一段文字', desc: '润色 / 缩写 / 扩写 / 降重' },
    { icon: <ImageIcon size={16} />, title: '点击一张图片', desc: '按要求重新生成图片' },
    { icon: <TableIcon size={16} />, title: '点击表格', desc: '调整表格结构和数据' },
    { icon: <Sigma size={16} />, title: '点击公式', desc: '修改公式表达式' },
];

/**
 * 局部修改页签的空状态：引导用户在正文中选中内容
 */
const EmptyPanel = () => {
    return (
        <div className={styles.emptyPanel}>
            <div className={styles.emptyPanelTitle}>在正文中选中要修改的内容</div>
            <div className={styles.emptyPanelDesc}>
                局部修改只改动你选中的那一小块，其余内容保持不变。
            </div>
            <ul className={styles.hintList}>
                {HINTS.map((hint) => (
                    <li key={hint.title} className={styles.hintItem}>
                        <span className={styles.hintIcon}>{hint.icon}</span>
                        <span className={styles.hintText}>
                            <strong>{hint.title}</strong>
                            <span>{hint.desc}</span>
                        </span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default EmptyPanel;
